module.exports = __webpack_public_path__ + "img/ws-icon-500x500.fbd6b638.png";